import { action, flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { ResponseData } from '@/types/http';
import { GetAllShopSearchPromotiongResponse } from '@/types/http-payload/shop';
import { PromotionApi } from '@/apis';
import { TableState } from '@tanstack/react-table';
import { GetPetOwnerListDetailResponse } from '@/types/http-payload/appointment';

export default class PromotionStore extends BaseStore {
    shopsSearchPromotion: any[] = [];
    api: PromotionApi;
    promotions: any[] = [];
    promotionDetail: any;
    totalByStatus: Object = {};
    dataPetOwnerListDetail: GetPetOwnerListDetailResponse = {
        data: [],
        total: 0
    };

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            shopsSearchPromotion: observable,
            promotions: observable,
            promotionDetail: observable,
            dataPetOwnerListDetail: observable,
            getAllShopSearchPromotion: flow.bound,
            postPromotion: flow.bound,
            getDetailPromotion: flow.bound,
            deletePromotion: flow.bound,
            updatePromotion: flow.bound,
            getAllPromotion: flow.bound,
            getDataPetOwnerListDetail: flow.bound,
            changeStatusPromotion: flow.bound
        });

        this.api = new PromotionApi();
    }

    *getAllShopSearchPromotion(searchParams: any) {
        try {
            const res: ResponseData<GetAllShopSearchPromotiongResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAllShopSearchPromotion, searchParams, { hideLoading: true });
            if (res.ok) {
                this.shopsSearchPromotion = res.data.elements;
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *getDataPetOwnerListDetail(searchParams: any) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getDataPetOwnerListDetail, searchParams, { hideLoading: true });
            if (res.ok) {
                this.dataPetOwnerListDetail = res.data;
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *getAllPromotion(searchParams: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetAllShopSearchPromotiongResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAllPromotion, payload);
            if (res.ok) {
                this.promotions = res.data.elements;
                this.totalByStatus = res.data.totalByStatus;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
            }
        } catch (error) {
            console.log(error);
        }
    }

    * postPromotion(payload?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.postPromotion, payload);
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *getDetailPromotion(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getDetailPromotion, id);
            if (res.ok) {
                this.promotionDetail = res.data;
                return res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *deletePromotion(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deletePromotion, id);
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *updatePromotion(id: string, payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updatePromotion, { id, payload });
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *changeStatusPromotion(id: string, payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.changeStatusPromotion, { id, payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
